import { useEffect, useState } from 'react';
import countdownBeepAudio from '../../../../assets/audio/countdown_beep.mp3';
import startBeepAudio from '../../../../assets/audio/start_beep.mp3';
import startAudio from '../../../../assets/audio/start.mp3';
import workoutDoneAudio from '../../../../assets/audio/workout_done.mp3';

const audioSound = {
  countdownBeep: countdownBeepAudio,
  startBeep: startBeepAudio,
  start: startAudio,
  workoutDone: workoutDoneAudio,
};

let setAudioSound = false;

const getTotalSeconds = (strTime) => {
  return strTime
    .split(':')
    .reduce((acc, curr) => Number(acc) * 60 + Number(curr));
};

const Running = ({ setting, getTotalWorkoutTime, setSetting }) => {
  const [status, setStatus] = useState('READY');
  const [started, setStarted] = useState(false);
  const [pausedAt, setPausedAt] = useState('');
  const [runPrepTime, setRunPrepTime] = useState(
    getTotalSeconds(setting.prepTime)
  );
  const [runExerciseTime, setRunExerciseTime] = useState(
    getTotalSeconds(setting.exerciseTime)
  );
  const [runRestTime, setRunRestTime] = useState(
    getTotalSeconds(setting.exerciseRestTime)
  );
  const [runTabataRestTime, setRunTabataRestTime] = useState(
    getTotalSeconds(setting.tabataRestTime)
  );
  const [round, setRound] = useState(0);
  const [tabata, setTabata] = useState(0);

  useEffect(() => {
    setRunPrepTime(getTotalSeconds(setting.prepTime));
    setRunExerciseTime(getTotalSeconds(setting.exerciseTime));
    setRunRestTime(getTotalSeconds(setting.exerciseRestTime));
    setRunTabataRestTime(getTotalSeconds(setting.tabataRestTime));
  }, [
    setting.prepTime,
    setting.exerciseTime,
    setting.exerciseRestTime,
    setting.tabataRestTime,
  ]);

  useEffect(() => {
    let runPrep;

    if (status === 'PREP') {
      console.log('prep started');
      // prep timer
      let prepTime = runPrepTime;
      setRunPrepTime(prepTime);
      setRound(0);
      setTabata(0);

      runPrep = setInterval(() => {
        prepTime--;
        setRunPrepTime(prepTime);

        if (prepTime === 3 || prepTime === 2 || prepTime === 1) {
          (async () => {
            await audioSound.countdownBeep.play();
          })();
        }
        if (prepTime === 0) {
          (async () => await audioSound.start.play())();
        }
        if (prepTime === -1) {
          clearInterval(runPrep);
          setRunPrepTime(getTotalSeconds(setting.prepTime));
          setRound((prev) => prev + 1);
          setTabata((prev) => prev + 1);
          setStatus('EXERCISE');
        }
      }, 1000);
    }
    if (status === 'PAUSE') {
      clearInterval(runPrep);
    }

    return () => {
      clearInterval(runPrep);
    };
  }, [status]);

  useEffect(() => {
    let runExercise;

    if (status === 'EXERCISE') {
      console.log('exercise timer');
      // exercise timer
      let exerciseTime = runExerciseTime;
      setRunExerciseTime(exerciseTime);
      runExercise = setInterval(() => {
        exerciseTime--;
        setRunExerciseTime(exerciseTime);

        if (exerciseTime === 3 || exerciseTime === 2 || exerciseTime === 1) {
          (async () => {
            await audioSound.countdownBeep.play();
          })();
        } else if (exerciseTime === 0) {
          (async () => await audioSound.startBeep.play())();
        } else if (exerciseTime === -1) {
          clearInterval(runExercise);
          setRunExerciseTime(getTotalSeconds(setting.exerciseTime));

          if (round < setting.totalRound) {
            setStatus('REST');
          } else {
            setStatus('SETREST');
          }
        }
      }, 1000);
    }
    if (status === 'PAUSE') {
      clearInterval(runExercise);
    }

    return () => {
      clearInterval(runExercise);
    };
  }, [status]);

  useEffect(() => {
    let runRest;

    if (status === 'REST') {
      console.log('rest timer');
      let restTime = runRestTime;
      setRunRestTime(restTime);
      runRest = setInterval(() => {
        restTime--;
        setRunRestTime(restTime);

        if (restTime === 3 || restTime === 2 || restTime === 1) {
          (async () => {
            await audioSound.countdownBeep.play();
          })();
        } else if (restTime === 0) {
          (async () => await audioSound.startBeep.play())();
        } else if (restTime === -1) {
          clearInterval(runRest);
          setRunRestTime(getTotalSeconds(setting.exerciseRestTime));

          if (round < setting.totalRound) {
            setRound((prev) => prev + 1);
            setStatus('EXERCISE');
          }
        }
      }, 1000);
    }
    if (status === 'PAUSE') {
      clearInterval(runRest);
    }

    return () => {
      clearInterval(runRest);
    };
  }, [status]);

  useEffect(() => {
    let runSetRest;

    if (status === 'SETREST') {
      console.log('set rest timer');
      let restTime = runTabataRestTime;
      setRunTabataRestTime(restTime);
      runSetRest = setInterval(() => {
        restTime--;
        setRunTabataRestTime(restTime);

        if (restTime === 3 || restTime === 2 || restTime === 1) {
          (async () => {
            await audioSound.countdownBeep.play();
          })();
        } else if (restTime === 0) {
          if (tabata < setting.totalTabata) {
            (async () => await audioSound.start.play())();
          }
        } else if (restTime === -1) {
          clearInterval(runSetRest);
          setRunTabataRestTime(getTotalSeconds(setting.tabataRestTime));

          if (tabata < setting.totalTabata) {
            setTabata((prev) => prev + 1);
            setRound(1);
            setStatus('EXERCISE');
          } else {
            (async () => await audioSound.workoutDone.play())();
            setStatus('DONE');
            setPausedAt('');
            setStarted(false);
          }
        }
      }, 1000);
    }
    if (status === 'PAUSE') {
      clearInterval(runSetRest);
    }

    return () => {
      clearInterval(runSetRest);
    };
  }, [status]);

  const startAndStopTimer = () => {
    if (!setAudioSound) {
      for (let [key, audio] of Object.entries(audioSound)) {
        const sound = new Audio(audio);
        audioSound[key] = sound;
      }
      setAudioSound = true;
    }

    if (!setting.totalTabata) {
      alert('Add one set at least!');
    } else if (!setting.totalRound) {
      alert('Add one round at least!');
    } else if (started) {
      window.location.reload();
    } else {
      setStarted(true);
      setStatus('PREP');
    }
  };

  const reset = () => {
    setStatus('READY');
    setSetting({
      totalTabata: 4,
      totalRound: 3,
      exerciseTime: '00:20',
      exerciseRestTime: '00:10',
      prepTime: '00:30',
      tabataRestTime: '00:30',
    });
    setRound(0);
    setTabata(0);
  };

  const pauseAndResumeTimer = () => {
    setPausedAt(status);
    if (status !== 'PAUSE') {
      setStatus('PAUSE');
    } else if (status === 'PAUSE') {
      if (pausedAt === 'PREP') {
        setStatus('PREP');
      } else if (pausedAt === 'EXERCISE') {
        setStatus('EXERCISE');
      } else if (pausedAt === 'REST') {
        setStatus('REST');
      } else if (pausedAt === 'SETREST') {
        setStatus('SETREST');
      }
    }
  };

  return (
    <div className='bg-secondary p-3 rounded-xl border border-tertiary'>
      <div
        className='p-2 rounded-xl text-center mb-3'
        style={{
          backgroundColor:
            status === 'PREP'
              ? '#ffff00'
              : status === 'EXERCISE'
              ? '#00ff00'
              : status === 'REST'
              ? '#ff0000'
              : status === 'SETREST'
              ? 'orange'
              : status === 'PAUSE' && pausedAt === 'PREP'
              ? '#ffff00'
              : status === 'PAUSE' && pausedAt === 'EXERCISE'
              ? '#00ff00'
              : status === 'PAUSE' && pausedAt === 'REST'
              ? '#ff0000'
              : status === 'PAUSE' && pausedAt === 'SETREST'
              ? 'orange'
              : '#fff',
        }}
      >
        <div className='text-4xl font-bold'>
          {status === 'PREP'
            ? 'Ready~!'
            : status === 'EXERCISE'
            ? 'Exercise'
            : status === 'REST'
            ? 'Rest'
            : status === 'SETREST'
            ? 'Set rest'
            : status === 'PAUSE'
            ? 'Pause'
            : status === 'DONE'
            ? 'Workout Completed!'
            : 'Workout time'}
        </div>
        <div className='text-6xl font-extrabold'>
          {!started
            ? getTotalWorkoutTime()
            : status === 'PREP'
            ? runPrepTime
            : status === 'EXERCISE'
            ? runExerciseTime
            : status === 'REST'
            ? runRestTime
            : status === 'SETREST'
            ? runTabataRestTime
            : status === 'PAUSE' && pausedAt === 'PREP'
            ? runPrepTime
            : status === 'PAUSE' && pausedAt === 'EXERCISE'
            ? runExerciseTime
            : status === 'PAUSE' && pausedAt === 'REST'
            ? runRestTime
            : status === 'PAUSE' && pausedAt === 'SETREST'
            ? runTabataRestTime
            : getTotalWorkoutTime()}
        </div>
      </div>

      <div className='flex justify-center items-center gap-3 mb-3'>
        <div className='text-4xl bg-white p-2 rounded-xl text-center font-extrabold flex-1'>
          <div>
            {round} / {setting.totalRound}
          </div>
          <div className='text-3xl font-medium tracking-tight'>Exercise</div>
        </div>
        <div className='text-4xl bg-white p-2 rounded-xl text-center font-extrabold flex-1'>
          <div>
            {tabata} / {setting.totalTabata}
          </div>
          <div className='text-3xl font-medium tracking-tight'>Set</div>
        </div>
      </div>
      {started && (
        <div className='flex justify-between items-center gap-3 text-2xl'>
          <button
            className='w-1/2 py-2  bg-white rounded-xl'
            onClick={startAndStopTimer}
          >
            Finish
          </button>
          <button
            className='w-1/2 py-2  bg-white rounded-xl'
            onClick={pauseAndResumeTimer}
          >
            {status !== 'PAUSE' ? 'Pause' : 'Resume'}
          </button>
        </div>
      )}
      {!started ? (
        status === 'DONE' ? (
          <div className='flex justify-between items-center gap-3 text-2xl'>
            <button
              className='w-1/2 py-2  bg-white rounded-xl'
              onClick={startAndStopTimer}
            >
              Restart!
            </button>
            <button
              className='w-1/2 py-2  bg-white rounded-xl'
              onClick={reset}
            >
              Reset
            </button>
          </div>
        ) : (
          <div className='flex justify-center items-center text-2xl'>
            <button
              className='w-full py-2  bg-white rounded-xl'
              onClick={startAndStopTimer}
            >
              Start
            </button>
          </div>
        )
      ) : null}
    </div>
  );
};

export default Running;
